import React, { Component } from 'react'
import { connect } from 'react-redux'
import PDFDialogView from './PDFDialogView'

class DialogPdfAfip extends Component {
  render () {
    const { cpa, closeCallback } = this.props
    return (
      <PDFDialogView className='dialog-foto-patente' cpa={cpa} closeCallback={closeCallback} />
    )
  }
}

const mapStateToProps = state => {
  return {
    cpa: state.camionesIngreso.consultaCpa
  }
}
export default connect(mapStateToProps)(DialogPdfAfip)
